export default {
  logs: state => state.logs,
  currentPage: state => state.currentPage,
  lastPage: state => state.lastPage,
  totalItems: state => state.totalItems,
  isCallingLogs: state => state.isCallingLogs
}
